import { render, staticRenderFns } from "./SitePermits.vue?vue&type=template&id=278dd288"
import script from "./SitePermits.vue?vue&type=script&lang=js"
export * from "./SitePermits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports